(function () {
  const header = document.querySelector('header');
  if (!header) return;

  function setHeaderHeightVar() {
    document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
  }

  setHeaderHeightVar();
  window.addEventListener('resize', setHeaderHeightVar);

  const revealThreshold = 8; // ignore tiny scroll jitters (mobile bounce, etc.)
  let lastScrollY = window.scrollY;
  let ticking = false;

  function isAnyOverlayOpen() {
    return (
      document.documentElement.classList.contains('mobile-nav-drawer-open') ||
      document.documentElement.classList.contains('search-modal-open') ||
      header.querySelector('.mega-menu.is-visible')
    );
  }

  function onScroll() {
    const currentScrollY = window.scrollY;

    if (isAnyOverlayOpen()) {
      header.classList.remove('header--hidden');
      lastScrollY = currentScrollY;
      ticking = false;
      return;
    }

    if (currentScrollY <= header.offsetHeight) {
      // Always show the header near the top of the page.
      header.classList.remove('header--hidden');
    } else if (currentScrollY - lastScrollY > revealThreshold) {
      // Scrolling down past the threshold.
      header.classList.add('header--hidden');
    } else if (lastScrollY - currentScrollY > revealThreshold) {
      // Scrolling up past the threshold.
      header.classList.remove('header--hidden');
    }

    lastScrollY = currentScrollY;
    ticking = false;
  }

  window.addEventListener(
    'scroll',
    () => {
      if (!ticking) {
        requestAnimationFrame(onScroll);
        ticking = true;
      }
    },
    { passive: true }
  );
})();
